/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import getCompositeInputField from './_compositeInputField.css';
import getCheckboxToggleButtonField from './_checkbox-toggle-button-field.css';
import getIconCheckField from './_icon-check-field.css';

const styles = [getCompositeInputField, getCheckboxToggleButtonField, getIconCheckField];

export default $ => css(styles.map(style => style($)));
